import { Link } from 'react-router-dom';
import Fumigation from '../images/fumigation.jpg';
import './homeservicestwo.css';

const HomeServicesTwo = () => {
    return (
        <div className="home_services_two">
            <div className="container home_services_two_container">
                <div className="home_services_two_content">
                    <div className="fumigation">
                        <div className="fumigation_content">
                            <h3>Fumigation services</h3>
                            <p>Our fumigation services are designed to eradicate pests in large-scale environments, such as warehouses, factories, and shipping containers.</p>
                            <Link to="./fumigation-services" className='btn btn-sm btn-fumigation'>Learn More</Link>
                        </div>
                        <div className="fumigation_img">
                            < img src={Fumigation} alt="fumigation" />
                        </div>
                    </div>
                    <div className="pest_control">
                        <div className='bird-control-cont'>
                            <Link to="./bird-control">
                                <div className='bird-control'>
                                    <h3>Bird control:</h3>
                                    <p>We offer humane solutions to keep birds away from your property without harming them.</p>
                                </div>
                            </Link>
                        </div>
                        <div className='consultancy-cont'>
                            <Link to="./consultancy-training">
                                <div className='consultancy'>
                                    <h3>Consultancy & training:</h3>
                                    <p>Our experts are available to provide advice and training on pest control measures to prevent future infestations.</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default HomeServicesTwo